//UserInterface to define the State type for the state of the reducer

import {
  GET_SERVICE_CENTER_FAILED_LL,
  GET_SERVICE_CENTER_SUCCESS_LL,
  RESET_LL_DATA,
} from "../actionConstants";

interface AppInterface {
  // siteList: any;
  serviceCenterList: any;
  // subRecipientList: any;
  // classroomList: any;
}

interface Actions {
  payload: any;
  type: string;
  token: string;
}

//State type for defining the state of the reducer
export type State = AppInterface;

//Initial state of the reducer of type State
export const initialState: State = {
  // siteList: [],
  serviceCenterList: [],
  // subRecipientList: [],
  // classroomList: [],
};

export const LLReducers = (state: State = initialState, action: Actions) => {
  switch (action.type) {
    //if action is of type SIGN_IN or SIGN_UP return the state by setting token to the payload
    // case GET_SITE_SUCCESS:
    //     return {
    //         ...state,
    //         siteList: action.payload.data,
    //     };
    // case GET_SITE_FAILED:
    //     return {
    //         ...state,
    //         userList: [],
    //     };
    case GET_SERVICE_CENTER_SUCCESS_LL:
      return {
        ...state,
        serviceCenterList: action.payload.data,
      };
    case GET_SERVICE_CENTER_FAILED_LL:
      return {
        ...state,
        serviceCenterList: [],
      };

    case RESET_LL_DATA:
      return {
        ...state,
        serviceCenterList: [],
      };
    // case GET_SUB_RECIPIENT_SUCCESS:
    //     return {
    //         ...state,
    //         subRecipientList: action.payload.data,
    //     };
    // case GET_SUB_RECIPIENT_FAILED:
    //     return {
    //         ...state,
    //         subRecipientList: [],
    //     };
    // case GET_CLASSROOM_SUCCESS:
    //     return {
    //         ...state,
    //         classroomList: action.payload.data,
    //     };
    // case GET_CLASSROOM_FAILED:
    //     return {
    //         ...state,
    //         classroomList: [],
    //     };
    default:
      return state;
  }
};
